import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hc-group__LOGO" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "text-center mb-6" }
const _hoisted_4 = ["src"]

import { Ref, computed, ref, onMounted } from 'vue';
import axios from 'axios';
import router from '@/router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useTheme } from "vuetify";

import { AUTH_LOGIN_URL, MINAS_CONFIG, changeURL, TIMEOUTTIME } from '@/constants/apis';
import { TOKEN, VISIBLE_PAGES } from '@/constants/labels';
import { showConsoleError } from '@/functions/errors';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

const store = useStore();
const { t } = useI18n();
const theme = useTheme();

onMounted(() => {
  theme.change('darkCustom');
});

const projectName = computed(() => store.state.projectName);
const isRAOS = computed(() => projectName.value === 'SmartLinkRAOS');

const valid: Ref<boolean> = ref(false);
const loading: Ref<boolean> = ref(false);
const userName: Ref<string> = ref('');
const password: Ref<string> = ref('');
const iconAppend = ref('mdi-eye');
const typePassword = ref('password');
const boolPassword = ref(true);

const fieldPassRules = ref([
  (value: string) => !!value || t('labels.errors.passRequired')
]);

const fieldUserRules = computed(() => [
  (v: string) => !!v || t('labels.errors.userRequired'),
  (v: string) => (v && v.length >= 4) || t('labels.errors.userError'),
]);

const changeType = () => {
  boolPassword.value = !boolPassword.value;
  iconAppend.value = boolPassword.value ? 'mdi-eye' : 'mdi-eye-off';
  typePassword.value = boolPassword.value ? 'password' : 'text';
};

const submit = async () => {
  if (!valid.value) return;
  loading.value = true;

  try {
    const response = await axios.post(
      AUTH_LOGIN_URL,
      { 
        user: userName.value, 
        pass: password.value 
      },
      {
        timeout: TIMEOUTTIME,
        headers: { 
          "Authorization": `Bearer ${TOKEN}`,
          "Content-Type": "application/json"
        }
      }
    );

    const sesion = response.data.body;

    if (sesion.status === 'User Found') {
      localStorage.setItem('user', sesion.user);
      localStorage.setItem('rol', sesion.rol);
      store.commit('setUserSesion', sesion);
      // store.commit('setUserRol', sesion.rol);
      // store.commit('')

      // CASO 1: Desarrollador -> Redireccionar al Selector de Minas
      if (sesion.rol === 'desarrollador') {
        router.push('/principalPage');
        store.commit('setAppBarPage', 'principalPage');
      } 
      // CASO 2: Trabajador de Mina -> Redireccionar directo a su Dashboard
      else if (sesion.rol === 'trabajador_mina' && sesion.mina) {
        const keyMina = sesion.mina as keyof typeof MINAS_CONFIG;
        const configMina = MINAS_CONFIG[keyMina];

        if (configMina) {
          changeURL(configMina.index);
          store.commit('setProjectName', configMina.name);
          store.commit('setProjectLAT', configMina.lat);
          store.commit('setProjectLNG', configMina.lng);
          store.commit('setProjectZOOM', configMina.zoom);

          const finalURLTarget = isRAOS.value
            ? `/smartlinkRAOS/${VISIBLE_PAGES.raosinit}`
            // : `/smartlink/${VISIBLE_PAGES.dashboard}`;
            : configMina.index === 3 ? `/smartlink/cemex/${VISIBLE_PAGES.tepeaca.dashboard}`
            : `/smartlink/${VISIBLE_PAGES.dashboard}`;

          router.push(finalURLTarget);
          store.commit('setAppBarPage', 'smartlinkPage');
        }
      }
    }
  } catch (error: any) {
    let msg = t('snackbar.login.passWrong');
    if (error.response && error.response.status === 404) {
      msg = t('snackbar.login.userNotFound');
    }
    userName.value = '';
    password.value = '';
    store.dispatch('showSnackBar', { type: 'setSnackError', msg });
    showConsoleError(error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "login-wrapper fill-height d-flex align-center justify-center"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          width: 110,
          alt: "Logo HC Group",
          src: require('@/assets/Images/hcgroup.jpg'),
          class: "brand-logo"
        }, null, 8, _hoisted_2)
      ]),
      _createVNode(_component_v_row, {
        justify: "center",
        align: "center",
        class: "w-100"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "10",
            md: "8",
            lg: "5",
            xl: "4"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                (!isRAOS.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      width: 300,
                      alt: "Logo Smart Link",
                      src: require('@/assets/Images/logoSmartLink.png'),
                      class: "mb-2 img-fluid"
                    }, null, 8, _hoisted_4))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "login-title" }, [
                        _createTextVNode("SmartLink™ "),
                        _createElementVNode("span", { class: "highlight" }, "RAOS")
                      ], -1)),
                      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "login-subtitle" }, "Remote & Autonomous Operation System", -1))
                    ], 64))
              ]),
              _createVNode(_component_v_card, { class: "login-card elevation-16 pa-6 pa-md-8" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, { class: "text-h5 text-center font-weight-bold mb-4 card-title-text" }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode(" Iniciar Sesión ", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_v_form, {
                    modelValue: valid.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((valid).value = $event)),
                    onSubmit: _withModifiers(submit, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: userName.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((userName).value = $event)),
                        rules: fieldUserRules.value,
                        label: _unref(t)('labels.user'),
                        "prepend-inner-icon": "mdi-account-hard-hat",
                        variant: "outlined",
                        density: "comfortable",
                        class: "mb-3 custom-input",
                        color: "bgCircular",
                        required: ""
                      }, null, 8, ["modelValue", "rules", "label"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((password).value = $event)),
                        rules: fieldPassRules.value,
                        type: typePassword.value,
                        "append-inner-icon": iconAppend.value,
                        label: _unref(t)('labels.pass'),
                        "prepend-inner-icon": "mdi-lock-outline",
                        variant: "outlined",
                        density: "comfortable",
                        class: "mb-2 custom-input",
                        color: "bgCircular",
                        "onClick:appendInner": changeType,
                        required: ""
                      }, null, 8, ["modelValue", "rules", "type", "append-inner-icon", "label"]),
                      _createVNode(_component_v_row, {
                        class: "mt-4",
                        dense: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, { cols: "12" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_btn, {
                                type: "submit",
                                color: "btnSelect",
                                block: "",
                                size: "large",
                                class: "btn-modern font-weight-bold text-white",
                                disabled: !valid.value || loading.value,
                                loading: loading.value,
                                elevation: "4"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(t)('buttons.login')), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "loading"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})